import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import Lenis from "@studio-freight/lenis"
import ScrollToPlugin from "gsap/ScrollToPlugin"
import { SplitText } from "gsap/SplitText"

jQuery(initGsapAnimations)

const isMobile = window.innerWidth < 1024

// Refresh animazioni
let resizeTimeout
// storage callback richiamati al refresh scrolltrigger
let refreshCallbacks = []

function initGsapAnimations() {
  gsap.registerPlugin(ScrollTrigger)
  gsap.registerPlugin(ScrollToPlugin)

  initLenis()
  initAnchorLinks()

  ScrollTrigger.config({
    limitCallbacks: true,
    ignoreMobileResize: true,
  })

  // animazioni devono essere inizializzate nell'ordine in cui appaiono in pagina;
  initPageScrollAnimations()

  //refresh layout listeners
  registerResizeListeners()
}

// LENIS scroll
let lenis

function initLenis() {
  if (isMobile) return

  lenis = new Lenis({
    duration: 1.1,
    smoothWheel: true,
    smoothTouch: false,
    easing: t => 1 - Math.pow(1 - t, 3),
  })

  lenis.on("scroll", ScrollTrigger.update)

  gsap.ticker.add(time => {
    lenis.raf(time * 1000)
  })

  gsap.ticker.lagSmoothing(0)
}

// Anchor link smooth scroll
function initAnchorLinks() {
  jQuery(document).on("click", 'a[href^="#"]', function (e) {
    const href = jQuery(this).attr("href")
    if (href === "#" || href.length < 2) return

    const target = document.querySelector(href)
    if (!target) return

    e.preventDefault()

    // Desktop uso scroll Lenis
    if (lenis) {
      lenis.scrollTo(target, {
        offset: 0,
        duration: 1,
        easing: t => 1 - Math.pow(1 - t, 3),
      })
    }
    // Mobile uso scroll nativo
    else {
      const top = target.getBoundingClientRect().top + window.pageYOffset - 56 // altezza header

      window.scrollTo({
        top,
        behavior: "smooth",
      })
    }
  })
}

function initPageScrollAnimations() {
  jQuery(".scroll-animation-container").each(function () {
    if (isMobile && jQuery(this).hasClass("animation-desktop-only")) return
    if (!isMobile && jQuery(this).hasClass("animation-mobile-only")) return
    if (jQuery("#hero-svg-elements-wrapper", this).length > 0) scrollHeroBg(this)
    if (jQuery(".gsap-text-scrub", this).length > 0) chartTextScrub(this)
    if (jQuery("#chart-section-elements-wrapper", this).length > 0) initChartAnimation(this)
    if (jQuery(".gsap-functional-wrapper", this).length > 0) functionalCardsScroll(this)
    if (jQuery(".gsap-partnership-wrapper", this).length > 0) partnershipCardsStacking(this)
    if (jQuery(".two-col-scroll__wrapper", this).length > 0) initTwoColScrollSection(this)
  })
}

// SCROLL HERO lottie in Hero section
function scrollHeroBg(parentNode) {
  if (isMobile) return
  gsap.to("#hero-svg-elements-wrapper path", {
    // stagger: 0.1,
    rotate: "+=360",
    transformOrigin: "50% 50%",
    scrollTrigger: {
      trigger: parentNode,
      scrub: true,
      pin: false,
      start: "-120px top",
      end: "bottom top",
    },
  })
}

// TEXT SCRUB in Chart section
function chartTextScrub(parentNode) {
  // attendo caricamento font
  document.fonts.ready.then(() => {
    const ctx = gsap.context(() => {
      const splitTypes = parentNode.querySelectorAll(".gsap-text-scrub")

      splitTypes.forEach(el => {
        const split = new SplitText(el, { types: "chars" })

        // stato iniziale forzato
        gsap.set(split.chars, { opacity: 0.2 })

        gsap.fromTo(
          split.chars,
          { opacity: 0.2 },
          {
            opacity: 1,
            stagger: 0.05,
            ease: "none",
            scrollTrigger: {
              trigger: parentNode,
              start: "top 80%",
              end: "top 20%",
              scrub: 0.5,
              invalidateOnRefresh: true,
              // markers: true,
            },
          }
        )
      })
    }, parentNode)

    // cleanup corretto su refresh / resize
    refreshCallbacks.push(() => ctx.revert())
  })
}

// CHART animations
function initChartAnimation(parentNode) {
  if (!isMobile) initChartDesktop(parentNode)
  initScrollCardChart()
}

// CHART CARDS SCROLL in Chart section
function initScrollCardChart() {
  // DESKTOP
  const wrapperSelector = isMobile ? ".mobile-chart" : ".desktop-chart"
  const $cards = jQuery("#chart-card-1, #chart-card-2, #chart-card-3", wrapperSelector)
  const gradientTitleHeight = jQuery("#gradient-title-home").height()

  let startPosition

  if (isMobile) {
    startPosition = "bottom bottom"
  } else {
    startPosition = window.innerHeight < 800 ? `${gradientTitleHeight}px top` : `-${gradientTitleHeight}px top`
  }

  const end = isMobile ? "+=20%" : "+=100%"
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: "#chart-section-wrapper",
      start: startPosition,
      end: end,
      scrub: 1,
      pin: !isMobile,
      ...getCommonScrollProps(),
      // markers: true,
    },
  })

  $cards.each(function (i) {
    tl.to(this, { opacity: 1, ease: "power2.out" })
  })
}

// CHART AUTOPLAY STEPS in Chart section
function initChartDesktop(parentNode) {
  const $steps = jQuery("#chart-step-1, #chart-step-2, #chart-step-3, #chart-step-4", ".desktop-chart")

  const cardWidth = 248

  let currentIndex = 0
  let intervalId = null
  let isHovering = false

  function openStep(index) {
    $steps.each(function (i) {
      const $text = jQuery(this).find("p")

      if (i === index) {
        // Step aperto
        gsap.to(this, {
          width: `${cardWidth}px`,
          x: "-30%",
          duration: 0.2,
          ease: "power2.out",
        })

        // text
        gsap.killTweensOf($text)
        gsap.to($text, {
          opacity: 1,
          delay: 0.2,
          duration: 0.3,
          ease: "power2.out",
          overwrite: true,
        })
      } else {
        // Step chiuso
        gsap.to(this, {
          width: "",
          x: 0,
          duration: 0.3,
          ease: "power2.out",
        })
        gsap.killTweensOf($text)
        gsap.set($text, { opacity: 0 })
      }
    })

    currentIndex = index
  }

  function nextStep() {
    const nextIndex = (currentIndex + 1) % $steps.length
    openStep(nextIndex)
  }

  function startAutoplay() {
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(() => {
      if (!isHovering) nextStep()
    }, 3000)
  }

  $steps.each(function (i) {
    jQuery(this).on("mouseenter", () => {
      isHovering = true
      openStep(i)
    })
    jQuery(this).on("mouseleave", () => {
      isHovering = false
      gsap.to(this, { width: "", x: 0, duration: 0.3, ease: "power2.out" })

      gsap.killTweensOf(jQuery(this).find("p"))
      gsap.set(jQuery(this).find("p"), { opacity: 0 })
    })
  })

  // inizializzazione
  openStep(0)

  ScrollTrigger.create({
    trigger: ".desktop-chart #chart-section-elements-wrapper",
    start: "bottom bottom",
    onEnter: self => startAutoplay(),
  })
}

// CARDS SCROLL in Functional services
function functionalCardsScroll(parentNode) {
  const $functionalWrapper = jQuery(".gsap-functional-wrapper", parentNode)
  const $functionalCards = jQuery(".gsap-functional-card", parentNode)

  const startPosition = isMobile ? "180px top" : "top top"

  if ($functionalWrapper.length && $functionalCards.length > 1) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: parentNode,
        start: startPosition,
        end: "+=200%",
        scrub: 1,
        pin: true,
        ...getCommonScrollProps(),
        // markers: true,
      },
    })

    // prima scrollata senza
    tl.to({}, { duration: 0.1 })

    $functionalCards.each(function (i) {
      if (i === 0) return true // salto il primo elemento che è sempre visibile

      const $prevSection = jQuery(`.bg-fun-card-${i}`)

      tl.to($prevSection[0], { autoAlpha: 0, y: "-100%" })
      tl.to(this, { autoAlpha: 1, y: 0 }, ">-70%")
    })
  }
}

// CARDS STACKING in Partnership
function partnershipCardsStacking(parentNode) {
  const $cards = jQuery(".gsap-partnership-card", parentNode)
  const startPosition = window.innerWidth < 768 ? "80px top" : "top top"
  if ($cards.length === 0) return
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: parentNode,
      start: startPosition,
      end: "+=150%",
      scrub: 1,
      pin: true,
      ...getCommonScrollProps(),
      // markers: true,
    },
  })

  let cardRotation = 2
  $cards.each(function (i) {
    if (i === 0) {
      tl.to(this, {
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1,
        duration: 1,
      })
    } else {
      tl.to(
        this,
        {
          opacity: 1,
          x: 0,
          y: 0,
          rotate: cardRotation * i,
          scale: 1,
          duration: 1,
        },
        ">-20%"
      )
    }
  })
}

// CARDS SCROLL in Twocolscroll
function initTwoColScrollSection(parentNode) {
  const $sections = jQuery(".two-col-scroll__section", parentNode)
  if ($sections.length === 0) return

  let startPosition = "center center"
  if (window.innerWidth < 1024) {
    const styles = getComputedStyle(document.documentElement)
    const headerHeight = styles.getPropertyValue("--header-height").trim().replaceAll("px", "")
    startPosition = `-${Number(headerHeight) + 16}px top` // altezza header + padding
  }

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: parentNode,
      start: startPosition,
      end: `+=${$sections.length}00%`,
      scrub: 1,
      pin: true,
      ...getCommonScrollProps(),
      // markers: true,
    },
  })

  $sections.each(function (i) {
    if (i === 0) return true // salto il primo elemento che è sempre visibile

    const $prevSection = jQuery(`.two-col-scroll__section-id-${i}`)
    const $prevTextCol = jQuery(".two-col-scroll__text-col", $prevSection)
    const $prevImgCol = jQuery(".two-col-scroll__img-col", $prevSection)
    const $textCol = jQuery(".two-col-scroll__text-col", this)
    const $imgCol = jQuery(".two-col-scroll__img-col", this)

    tl.to($prevTextCol[0], { autoAlpha: 0, y: "-50px" })
      .to($prevImgCol[0], { autoAlpha: 0 }, "<")

      .fromTo($textCol[0], { autoAlpha: 0, y: "50px" }, { autoAlpha: 1, y: 0 }, ">-10%")
      .fromTo($imgCol[0], { autoAlpha: 0 }, { autoAlpha: 1 }, "<")
  })
}

function registerResizeListeners() {
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout)

    resizeTimeout = setTimeout(() => {
      // initGsapAnimations()
      ScrollTrigger.refresh()
      lenis?.resize()
    }, 200)
  })
}

function getCommonScrollProps() {
  return {
    anticipatePin: 1,
    invalidateOnRefresh: true,
  }
}
